import { AppNav } from 'components/AppNav';
import MainLayout from 'components/Layouts/MainLayout';
import { H5 } from 'components/Text';
import React from 'react';
import { palette } from 'component-library';
import _capitalize from 'lodash/capitalize';
import { useTranslation } from 'react-i18next';
import { SearchInput } from 'components/SearchInput';
import styled, { css } from 'styled-components';
import { useSelector } from 'react-redux';
import { getWorkOrderOps } from 'lib/selectors/getWorkOrderOps';
import WorkOrderCard from './WorkOrderCard';

const Row = styled.div`
  padding: 1rem;
  ${({ bgColor }) => {
    return css`
      background-color: ${bgColor};
    `;
  }}
  ${({ height }) => {
    return css`
      height: ${height};
    `;
  }}
`;

const WorkOrderGrouping = styled.div`
  display: flex;
  flex-wrap: wrap;
  background-color: ${palette.Grey200};
`;

const SelectWorkOrderOp = ({
  dispatch,
  handleOnClose = () => {},
  startJob,
  nextStep,
}) => {
  const { t } = useTranslation();
  const workOrderOps = useSelector(getWorkOrderOps);
  if (!workOrderOps) {
    return null;
  }

  return (
    <MainLayout.Container direction="column" overlay id="select-work-order-op">
      <AppNav
        iconColor={palette.Grey700}
        color={palette.White}
        onClose={handleOnClose}
      >
        <H5
          color={palette.Grey700}
          style={{
            width: '100%',
            textAlign: 'left',
            paddingLeft: '1.5rem',
            fontWeight: '500',
          }}
        >
          What&apos;s next?
        </H5>
      </AppNav>
      <Row
        bgColor={palette.Grey200}
        style={{ borderBottom: `solid 1px ${palette.Grey300}` }}
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();
            // setFilters({ ...filters, description });
          }}
        >
          <SearchInput
            inputProps={{
              value: '',
              onChange: () => {
                // return setDescription(value);
              },
              placeholder: _capitalize(t('search by keyword')),
            }}
            onSubmit={() => {
              // return setFilters({ ...filters, description });
            }}
          />
        </form>
      </Row>
      <Row bgColor={palette.Grey200} height="100%">
        <WorkOrderGrouping>
          {workOrderOps.map((workOrderOp) => {
            return (
              <WorkOrderCard
                key={workOrderOp.workOrderId}
                workOrderOp={workOrderOp}
                startJob={startJob}
                nextStep={nextStep}
                dispatch={dispatch}
              />
            );
          })}
        </WorkOrderGrouping>
      </Row>
    </MainLayout.Container>
  );
};

export default SelectWorkOrderOp;
